<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Project Valuation and Risk
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="rev"
              :label="this.localForm.rev"
              :items="projectEvalatualtionMethod"
              color="wplblue0"
              prepend-icon="grain"
              hint="screen method"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.val"
            :rules="ruleMustBeFilledANDLessThan50"
            prepend-icon="paid"
            hint="project valuation"
            suffix="AUD"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="life"
              :label="this.localForm.life"
              :items="plantLifeOptions"
              :rules="ruleNumberPositive"
              color="wplblue0"
              prepend-icon="work_history"
              hint="system life"
              suffix="years"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-text-field
            v-model="localForm.costl"
            :rules="ruleNumberPositive"
            prepend-icon="currency_exchange"
            suffix="AUD"
            hint="ops lifecycle cost"
            persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="risk"
              :label="this.localForm.risk"
              :items="businessRiskOptions"
              color="wplblue0"
              prepend-icon="fmd_bad"
              hint="project risk"
              persistent-hint
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormChar()"
              v-model="carbi"
              :label="this.localForm.carbi"
              :items="businessAreaImpactOptions"
              color="wplblue0"
              prepend-icon="factory"
              hint="carbon impact"
              persistent-hint
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Project Plan Comments
          </div>
        </v-layout>
        <v-layout row wrap class="ml-3 mr-2">
          <v-flex xs12>
            <v-textarea
            :change="updateFormChar()"
            :color="ui.textColor"
            :background-color="ui.btnColor"
            v-model="localForm.project"
            label="describe options consdiered and others"
            :disabled="false"
            :outline="true"
            :rules="ruleMustBeNotUndefinedANDLessThan2000"
            hint="project, plan, eveluation"
            auto-grow
            persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import busOptions from "@/data/options/mixins/busOptions.js";
import businessOptions from "@/data/options/mixins/businessOptions.js";
import timeOptions from "@/data/options/mixins/timeOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        costl: "",
        project: "",
        risk: "",
        rev: "",
        val: "",
        life: "",
        carbi: "" // carbon intensity / carbon imp
      },
      orgForm: {
        costl: "",
        project: "",
        risk: "",
        rev: "",
        val: "",
        life: "",
        carb: "", // carbon imp
        carbi: "" // carbon intensity / carbon imp
      },
      risk: "",
      rev: "",
      life: "",
      carbi: "" // carbon intensity / carbon imp
    };
  },
  watch: {
    risk() {
      this.localForm.risk = this.risk;
      this.updateFormChar();
    },
    rev() {
      this.localForm.rev = this.rev;
      this.updateFormChar();
    },
    life() {
      this.localForm.life = this.life;
      this.updateFormChar();
    },
    carbi() {
      this.localForm.carbi = this.carbi;
      this.updateFormChar();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.project = this.getDetail.char.project;
    this.localForm.risk = this.getDetail.char.risk;
    this.localForm.rev = this.getDetail.char.rev;
    this.localForm.val = this.getDetail.char.val;
    this.localForm.life = this.getDetail.char.life;
    this.localForm.carbi = this.getDetail.char.carbi;
    this.localForm.costl = this.getDetail.char.costl;

    this.orgForm.project = this.getDetail.char.project;
    this.orgForm.risk = this.getDetail.char.risk;
    this.orgForm.rev = this.getDetail.char.rev;
    this.orgForm.val = this.getDetail.char.val;
    this.orgForm.life = this.getDetail.char.life;
    this.orgForm.carbi = this.getDetail.char.carbi;
    this.orgForm.costl = this.getDetail.char.costl;
  },
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    busOptions,
    timeOptions,
    businessOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.driver !== this.orgForm.driver &&
        this.localForm.driver !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.driver = this.localForm.driver;
        // basic
        char.driver = this.localForm.driver;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(3.12, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.project !== this.orgForm.project &&
        this.localForm.project !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.project = this.localForm.project;
        // basic
        char.project = this.localForm.project;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (
        this.localForm.risk !== this.orgForm.risk &&
        this.localForm.risk !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.risk = this.localForm.risk;
        // basic
        char.risk = this.localForm.risk;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rev !== this.orgForm.rev &&
        this.localForm.rev !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rev = this.localForm.rev;
        // basic
        char.rev = this.localForm.rev;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.val !== this.orgForm.val &&
        this.localForm.val !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.val = this.localForm.val;
        // basic
        char.val = this.localForm.val;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.life !== this.orgForm.life &&
        this.localForm.life !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.life = this.localForm.life;
        // basic
        char.life = this.localForm.life;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carbi !== this.orgForm.carbi &&
        this.localForm.carbi !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carbi = this.localForm.carbi;
        // basic
        char.carbi = this.localForm.carbi;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.costl !== this.orgForm.costl &&
        this.localForm.costl !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.costl = this.localForm.costl;
        // basic
        char.costl = this.localForm.costl;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.11, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
